import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, signal } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom, Subscription } from 'rxjs';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { PermissaoAcessoService } from '../../services/permissao-acesso.service';
import { ProdutoService } from '../../services/produto.service';
import { EmpresaStateService } from '../../services/empresa-state.service';
import { removerLinhasCotacao } from '../../shared/observacao-cotacao.util';

type AbaProduto = 'tab1' | 'tab2';

interface ProdutoAlternativo {
    codprod: string;
    partNumber: string;
    descricao: string;
    codMarca: string;
    marca: string;
}

// @ts-ignore
@Component({
    selector: 'app-gpl-edicao-produtos',
    standalone: true,
    imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
    templateUrl: './gpl-edicao-produtos.component.html',
    styleUrl: './gpl-edicao-produtos.component.css'
})
export class GplEdicaoProdutosComponent implements OnInit, OnChanges, OnDestroy {

    /** Setado pelo Gateway (ex.: vindo do card "Produto Cadastrado com Sucesso!"
     * da tela de Cadastrar Produto) pra abrir esse produto direto na edição,
     * sem precisar buscar manualmente. */
    @Input() codProdAutoAbrir: string | null = null;
    /** Tela que abriu a Edicao (Lista de Produtos): ao salvar/descartar, volta pra ela. */
    @Input() origemEdicao: 'lista-produtos' | null = null;
    @Output() voltarOrigem = new EventEmitter<void>();
    private retornarAposOk = false;
    /** Avisa o Gateway que já consumiu o codProdAutoAbrir, pra ele limpar o
     * valor guardado -- senão, ao sair e voltar pra essa tela pelo menu
     * normal, ela reabriria automaticamente o mesmo produto de novo em vez
     * de mostrar a lista de últimas cotações. */
    @Output() codProdAutoAbrirConsumido = new EventEmitter<void>();
    /** Botão "Cadastrar" no header -- pede pro Gateway navegar de volta pra
     * tela de Cadastrar Produto (duplicar-produto), na etapa de seleção de
     * modelo (comportamento padrão dela ao ser recriada). */
    @Output() irParaCadastro = new EventEmitter<string | void>();
    /** "Clonar" na lista: pede ao Gateway para abrir o Cadastrar Produto já usando este produto como modelo. */
    @Output() clonarProduto = new EventEmitter<{ codprod: string; partNumber: string; nome: string; imagem?: string }>();
    private _ultimoCodProdAutoAbrir: string | null = null;

    carregando = signal(false);

    searchbox = true;
    telaVisivel = false;
    mostrarLista = false;
    mostrarListaCotacoes = false;

    abaAtiva: AbaProduto = 'tab1';

    filtro = {
        partNumber: '',
        nome: '',
        fabricante: '',
        codigo: null as number | null
    };

    form: any = {
        CODPROD: null,
        ativo: true,
        partNumber: '',
        descricao: '',
        codVol: '',
        tipContest: 'N',
        temCore: false,
        marca: '',
        condicao: 'NEW',
        obsInterna: '',
        obsTecnica: '',
        precoFabricante: '0.00',
        percentualCusto: '0.00',
        totalCusto: '0.00',
        percentualLucro: '0.00',
        precoVenda: '0.00',
        valorCore: '0.00',
        fornecedor: '',
        cotacaoalterada: '2',
        // Campos complementares (iguais ao Cadastrar Produto)
        labelUsa: '',
        eccn: '',
        scheduleB: '',
        codGrupo: '',
        controlaForm: 'N',
        matPerig: 'N',
        controlado: 'N',
        limitePF: '',
        limitePJ: '',
        pesoBruto: '0',
        pesoLiq: '0',
        ncm: ''
    };

    // Listas/modais de Grupo de Produto e NCM
    listaGrupos: { valor: string; label: string }[] = [];
    listaNcms: { valor: string; label: string }[] = [];
    modalGrupoAberto = false;
    modalNcmAberto = false;
    filtroGrupoModal = '';
    filtroNcmModal = '';
    private descricaoNcmAtual = '';

    get gruposFiltrados(): { valor: string; label: string }[] {
        const f = this.filtroGrupoModal.trim().toUpperCase();
        return f ? this.listaGrupos.filter(g => g.label.toUpperCase().includes(f)) : this.listaGrupos;
    }

    get ncmsFiltrados(): { valor: string; label: string }[] {
        const f = this.filtroNcmModal.trim().toUpperCase();
        if (f.length < 3) return [];
        return this.listaNcms.filter(n => n.label.toUpperCase().includes(f)).slice(0, 200);
    }

    private descricaoDeLista(lista: { valor: string; label: string }[], codigo: string): string {
        const op = lista.find(o => o.valor === (codigo || '').trim());
        if (!op) return '';
        const partes = op.label.split(' - ');
        return partes.length > 1 ? partes.slice(1).join(' - ') : '';
    }

    valorExibidoGrupo(codigo: string): string {
        const c = (codigo || '').trim();
        const d = this.descricaoDeLista(this.listaGrupos, c);
        return d ? `${c} - ${d}` : c;
    }

    valorExibidoNcm(codigo: string): string {
        const c = (codigo || '').trim();
        const d = this.descricaoDeLista(this.listaNcms, c) || this.descricaoNcmAtual;
        return d ? `${c} - ${d}` : c;
    }

    abrirBuscaGrupo(): void { this.filtroGrupoModal = ''; this.modalGrupoAberto = true; }
    fecharBuscaGrupo(): void { this.modalGrupoAberto = false; }
    selecionarGrupo(op: { valor: string; label: string }): void {
        this.form.codGrupo = op.valor;
        this.modalGrupoAberto = false;
        this.monitorarAlteracao();
    }
    limparGrupo(): void { this.form.codGrupo = ''; this.monitorarAlteracao(); }

    abrirBuscaNcm(): void { this.filtroNcmModal = ''; this.modalNcmAberto = true; }
    fecharBuscaNcm(): void { this.modalNcmAberto = false; }
    selecionarNcm(op: { valor: string; label: string }): void {
        this.form.ncm = op.valor;
        this.descricaoNcmAtual = '';
        this.modalNcmAberto = false;
        this.monitorarAlteracao();
    }
    onInputNcm(event: Event): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;
        const cursorPos = input.selectionStart ?? valorDigitado.length;
        const idx = valorDigitado.indexOf(' - ');
        const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;
        this.form.ncm = novoCodigo;
        this.descricaoNcmAtual = '';
        const novoValor = this.valorExibidoNcm(novoCodigo);
        this.monitorarAlteracao();
        setTimeout(() => {
            input.value = novoValor;
            const novaPos = Math.min(cursorPos, novoCodigo.length);
            input.setSelectionRange(novaPos, novaPos);
        });
    }
    limparNcm(): void { this.form.ncm = ''; this.descricaoNcmAtual = ''; this.monitorarAlteracao(); }

    // ── Tradução automática Descrição (PT) <-> Label (USA) (EN), igual ao Cadastrar Produto ──
    private labelUsaEditadoManual = false;
    private descricaoEditadaManual = false;
    private timerTraducaoPtEn: any = null;
    private timerTraducaoEnPt: any = null;

    /** Digitou na Descrição: marca como editada e traduz PT -> EN para o Label (se o Label não foi digitado). */
    onDescricaoChange(valor: string): void {
        valor = (valor ?? '').toUpperCase();
        this.form.descricao = valor;
        this.descricaoEditadaManual = true;
        this.monitorarAlteracao();
        if (this.labelUsaEditadoManual) return;
        if (this.timerTraducaoPtEn) clearTimeout(this.timerTraducaoPtEn);
        this.timerTraducaoPtEn = setTimeout(() => this.traduzirDescricaoParaLabel(valor), 300);
    }

    /** Digitou no Label (USA): marca como editado e traduz EN -> PT para a Descrição (se a Descrição não foi digitada). */
    onLabelUsaChange(valor: string): void {
        valor = (valor ?? '').toUpperCase();
        this.form.labelUsa = valor;
        this.labelUsaEditadoManual = true;
        this.monitorarAlteracao();
        if (this.descricaoEditadaManual) return;
        if (this.timerTraducaoEnPt) clearTimeout(this.timerTraducaoEnPt);
        this.timerTraducaoEnPt = setTimeout(() => this.traduzirLabelParaDescricao(valor), 300);
    }

    private traduzirDescricaoParaLabel(texto: string): void {
        const valor = (texto || '').trim();
        if (!valor || this.labelUsaEditadoManual) return;
        this.produtoService.traduzirParaIngles(valor).subscribe({
            next: (res: any) => {
                if (!res?.sucesso || !res?.traducao || this.labelUsaEditadoManual) return;
                this.form.labelUsa = String(res.traducao).toUpperCase();
                this.monitorarAlteracao();
            },
            error: () => { /* falha silenciosa */ }
        });
    }

    private traduzirLabelParaDescricao(texto: string): void {
        const valor = (texto || '').trim();
        if (!valor || this.descricaoEditadaManual) return;
        this.produtoService.traduzirParaPortugues(valor).subscribe({
            next: (res: any) => {
                if (!res?.sucesso || !res?.traducao || this.descricaoEditadaManual) return;
                this.form.descricao = String(res.traducao).toUpperCase();
                this.monitorarAlteracao();
            },
            error: () => { /* falha silenciosa */ }
        });
    }

    /** Toggle genérico S/N (Controla FORM, Perigoso). */
    onToggleSN(campo: 'controlaForm' | 'matPerig', event: Event): void {
        this.form[campo] = (event.target as HTMLInputElement).checked ? 'S' : 'N';
        this.monitorarAlteracao();
    }

    /** "Controlado": ao ligar preenche Limite PF = 5 e PJ = 200; ao desligar limpa (igual ao Cadastrar). */
    onToggleControlado(event: Event): void {
        const checked = (event.target as HTMLInputElement).checked;
        this.form.controlado = checked ? 'S' : 'N';
        this.form.limitePF = checked ? '5.00' : '';
        this.form.limitePJ = checked ? '200.00' : '';
        this.monitorarAlteracao();
    }

    /** Toggle "Ativo" do topo: abre a confirmação de inativar/reativar e mantém o visual até confirmar. */
    onToggleAtivoEdicao(event: Event): void {
        (event.target as HTMLInputElement).checked = !!this.form.ativo;
        if (this.form.ativo) this.solicitarInativarProduto();
        else this.solicitarReativarProduto();
    }

    onPesoFocus(campo: 'pesoBruto' | 'pesoLiq'): void {
        this.form[campo] = String(this.toNumber(this.form[campo]) || '');
    }

    onPesoBlur(campo: 'pesoBruto' | 'pesoLiq'): void {
        const n = this.toNumber(this.form[campo]);
        this.form[campo] = n.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
        this.monitorarAlteracao();
    }

    listaProdutos: any[] = [];
    listaUltimasCotacoes: any[] = [];
    cotacoes: any[] = [];

    listaFabricantes: any[] = [];
    listaFabricantesProduto: any[] = [];
    listaFabricantesModal: any[] = [];
    modalFabricantesAberto = false;
    filtroFabricanteModal = '';
    carregandoFabricantesModal = false;
    private fabricanteModalDestino: 'busca' | 'produto' | 'alternativo' = 'produto';
    listaVolumes: any[] = [];
    listaFornecedores: any[] = [];
    listaLocais: any[] = [];
    listaCondicoes = ['NEW', 'NS', 'OH', 'SV', 'AR', 'RP', 'RB', 'EX', 'REP'];
    listaCondicoesFiltradas: string[] = [];

    /** Opções do combo CD (valor/label), as mesmas do Cadastro de Produto. Vazio = usa listaCondicoes. */
    opcoesCondicao: { valor: string; label: string }[] = [];

    /** Opções exibidas no combo (do servidor; senão a lista fixa de códigos). */
    get opcoesCondicaoCombo(): { valor: string; label: string }[] {
        const base = this.opcoesCondicao.length
            ? this.opcoesCondicao
            : this.listaCondicoes.map(c => ({ valor: c, label: c }));
        const atual = (this.form?.condicao || '').trim();
        // Mantém visível um valor atual que não esteja na lista (evita o combo "perder" o valor).
        return atual && !base.some(o => o.valor === atual) ? [...base, { valor: atual, label: atual }] : base;
    }

    labelCondicao(valor: string): string {
        return this.opcoesCondicaoCombo.find(o => o.valor === valor)?.label ?? (valor || '');
    }

    // Dropdowns
    fornecedorDropdownAberto = false;
    volumeDropdownAberto = false;
    condicaoDropdownAberto = false;
    private fornecedorSelecionado = '';
    private fornecedorBuscaSeq = 0;

    produtosAlternativos: ProdutoAlternativo[] = [];
    produtosAlternativosBusca: ProdutoAlternativo[] = [];
    produtosAlternativosSelecionados: ProdutoAlternativo[] = [];
    modalProdutosAlternativosAberto = false;
    filtroProdutoAlternativo = '';
    marcaProdutoAlternativo = '';
    marcaProdutoAlternativoDescricao = '';
    carregandoProdutosAlternativos = false;
    salvandoProdutosAlternativos = false;
    private buscaAlternativosTimer: any = null;

    listaMiniaturas: any[] = [];
    listaImagens: any[] = [];
    imagemPrincipal: any = null;
    imagemAtual: any = null;
    indexImagem = 0;

    modalGaleria = false;
    mostrarModalImagem = false;
    mostrarModalSelecaoImagem = false;
    previewImagem = '';
    imagemTemp = '';
    imagensPendentes: { src: string; base64: string }[] = [];
    indexPadrao = -1;
    indexVisualizandoPendente = 0;
    abrirSelecaoImagemAposAviso = false;
    isPlaceholder = false;

    modalConfirm = false;
    modalOk = false;
    modalAv = false;
    modalErro = false;
    modalMensagem = '';
    modalMensagemOk = '';
    modalMensagemAv = '';
    modalMensagemErro = '';

    formAlterado = false;
    monitorarCotacao = false;
    cotacaoOriginal: any[] | null = null;
    estadoInicial = '';
    codprodTela = '';

    private timeoutBusca: any = null;
    private geracaoBuscaProduto = 0;
    cotacaoDolarDia = 0;
    private acaoConfirmar: (() => void) | null = null;

    // ─── Permissões de cotação ───────────────────────────────────────────────
    /** true = usuário tem EDTCOT → pode editar livremente */
    podeEditarCotacao = false;
    /** true = usuário tem EDTMAI → pode editar somente para cima */
    podeEditarCotacaoSomenteParaCima = false;
    /** true = usuário tem pelo menos uma das permissões acima */
    get cotacaoEditavel(): boolean {
        return this.podeEditarCotacao || this.podeEditarCotacaoSomenteParaCima;
    }

    /** Fabricante nacional (EMBRAER (NEIVA)): preços cadastrados direto em Reais, sem conversão pelo dólar. */
    get isMarcaNacional(): boolean {
        return (this.form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)';
    }

    get precoVendaEmReais(): string {
        const precoVenda = this.toNumber(this.form.precoVenda);
        if ((this.form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)') {
            return this.formatar2Casas(precoVenda);
        }
        if (this.cotacaoDolarDia <= 0) return '';
        return this.formatar2Casas(precoVenda * this.cotacaoDolarDia);
    }

    // ── Estoque atual (empresa selecionada) e modal com as demais filiais ──
    estoqueAtual: number | null = null;
    estoqueAtualCarregando = false;
    modalEstFilAberto = false;
    modalEstFilCarregando = false;
    modalEstFilErro = '';
    modalEstFilSemSaldoOutras = false;
    modalEstFilItens: { empresaId: number; empresa: string; qtde: number; local: string; atual: boolean }[] = [];

    private empresaAerosysSelecionada(): number {
        return Number(this.empresaStateService.selecionada) || 1;
    }

    async carregarEstoqueAtual(cod: number | string): Promise<void> {
        this.estoqueAtual = null;
        this.estoqueAtualCarregando = true;
        try {
            const mapa = await firstValueFrom(
                this.produtoService.buscarEstoqueAerosysLote([Number(cod)], this.empresaAerosysSelecionada()));
            const e = mapa?.[String(Number(cod))];
            this.estoqueAtual = e ? e.qtde : null;
        } catch {
            this.estoqueAtual = null;
        } finally {
            this.estoqueAtualCarregando = false;
        }
    }

    async abrirEstoqueFiliais(): Promise<void> {
        if (!this.form.CODPROD) return;
        this.modalEstFilItens = [];
        this.modalEstFilErro = '';
        this.modalEstFilAberto = true;
        this.modalEstFilCarregando = true;
        try {
            const r = await firstValueFrom(this.produtoService.estoqueFiliaisAerosys(
                String(this.form.CODPROD), this.empresaAerosysSelecionada()));
            const todas = r?.itens || [];
            this.modalEstFilItens = todas.filter(i => i.atual || (i.qtde || 0) !== 0);
            this.modalEstFilSemSaldoOutras = todas.length > 0 && !todas.some(i => !i.atual && (i.qtde || 0) !== 0);
            if (!todas.length) this.modalEstFilErro = 'Nenhuma filial encontrada para este item no Aerosys.';
        } catch {
            this.modalEstFilErro = 'Não foi possível carregar o estoque das filiais.';
        } finally {
            this.modalEstFilCarregando = false;
        }
    }

    fecharEstoqueFiliais(): void {
        this.modalEstFilAberto = false;
    }

    get totalEstoqueFiliais(): number {
        return this.modalEstFilItens.reduce((s, i) => s + (i.qtde || 0), 0);
    }

    constructor(
        private readonly sankhyaGateway: SankhyaGatewayService,
        private readonly permissaoAcesso: PermissaoAcessoService,
        private readonly produtoService: ProdutoService,
        private readonly empresaStateService: EmpresaStateService
    ) {}

    /** Best-effort: se falhar, o produto já foi salvo no Sankhya mesmo assim (ver ProdutoAerosysComponent#sincronizarEdicao). */
    private sincronizarEdicaoComAerosys(payloadEdicao: Record<string, unknown>): void {
        this.produtoService.sincronizarEdicaoProdutoAerosys(payloadEdicao).subscribe({
            error: (e) => console.warn('Falha ao sincronizar edicao do produto com o Aerosys:', e)
        });
    }

    solicitarInativarProduto(): void {
        if (!this.form.CODPROD) return;
        this.abrirModal(
            'Deseja realmente INATIVAR este produto? Ele será marcado como inativo no Sankhya e no Aerosys.',
            () => void this.alterarAtivoProduto(false)
        );
    }

    solicitarReativarProduto(): void {
        if (!this.form.CODPROD) return;
        this.abrirModal(
            'Deseja reativar este produto no Sankhya e no Aerosys?',
            () => void this.alterarAtivoProduto(true)
        );
    }

    private async alterarAtivoProduto(ativo: boolean): Promise<void> {
        try {
            const response = await firstValueFrom(
                this.produtoService.alterarAtivoProduto(String(this.form.CODPROD), ativo)
            );
            if (response?.sucesso) {
                this.form.ativo = ativo;
                this.abrirModalOk(ativo ? 'Produto reativado com sucesso.' : 'Produto inativado com sucesso.');
                if (response.avisoAerosys) {
                    console.warn(response.avisoAerosys);
                }
            } else {
                this.abrirModalErro(response?.erro || 'Erro ao alterar status do produto.');
            }
        } catch (e) {
            console.error('Erro ao alterar status do produto:', e);
            this.abrirModalErro('Erro ao alterar status do produto.');
        }
    }

    // Unidades de medida com nome/sigla em inglês (TGFVOL.GPL_NOMEINGLES / GPL_SIGLAINGLES).
    unidadesIngles: { codvol: string; nomeIngles: string; siglaIngles: string }[] = [];

    /** Unidade em inglês da CODVOL atualmente selecionada (acompanha a troca da unidade). */
    unidadeInglesAtual(): { nomeIngles: string; siglaIngles: string } | null {
        const cod = String(this.form.codVol ?? '').trim().toUpperCase();
        if (!cod) return null;
        return this.unidadesIngles.find(u => String(u.codvol ?? '').trim().toUpperCase() === cod) ?? null;
    }

    private inscricaoEmpresa: Subscription | null = null;

    ngOnDestroy(): void {
        this.inscricaoEmpresa?.unsubscribe();
    }

    ngOnInit(): void {
        // Trocou de empresa com a edicao aberta: recarrega o Estoque Atual (e o modal, se estiver aberto).
        this.inscricaoEmpresa = this.empresaStateService.empresaMudou.subscribe(() => {
            if (this.form.CODPROD) {
                void this.carregarEstoqueAtual(this.form.CODPROD);
                if (this.modalEstFilAberto) void this.abrirEstoqueFiliais();
            }
        });
        // CD (Condition Key): mesmas opções do Cadastro de Produto (combo).
        this.produtoService.buscarOpcoesCondicao().subscribe({
            next: (opcoes) => { this.opcoesCondicao = opcoes ?? []; },
            error: () => { this.opcoesCondicao = []; }
        });
        this.produtoService.buscarUnidadesMedidaIngles().subscribe({
            next: (lista) => { this.unidadesIngles = lista ?? []; },
            error: () => { this.unidadesIngles = []; }
        });
        this.produtoService.buscarGruposProduto().subscribe({
            next: (lista) => { this.listaGrupos = lista ?? []; },
            error: () => { this.listaGrupos = []; }
        });
        this.produtoService.buscarNcms().subscribe({
            next: (lista) => { this.listaNcms = lista ?? []; },
            error: () => { this.listaNcms = []; }
        });

        // Se já veio um CODPROD pra abrir direto (ver ngOnChanges), não carrega
        // a lista de últimas cotações -- os dois carregamentos são assíncronos
        // e corriam em paralelo, e a lista às vezes terminava depois e
        // sobrescrevia a tela de edição já aberta (mostrarListaCotacoes=true
        // por cima do telaVisivel=true que selecionarProduto tinha acabado
        // de setar).
        if (!this.codProdAutoAbrir) {
            this.listarUltimasCotacoes();
        }
        this.initTabEnter();
        this._carregarPermissoesCotacao();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['codProdAutoAbrir']) return;
        const cod = this.codProdAutoAbrir;
        if (cod && cod !== this._ultimoCodProdAutoAbrir) {
            this._ultimoCodProdAutoAbrir = cod;
            void this.selecionarProduto({ codigo: cod, isPlaceholder: false });
            this.codProdAutoAbrirConsumido.emit();
        }
    }

    private async _carregarPermissoesCotacao(): Promise<void> {
        const [edtcot, edtmai] = await Promise.all([
            this.permissaoAcesso.podeEditarCotacao(),
            this.permissaoAcesso.podeEditarCotacaoSomenteParaCima(),
        ]);
        this.podeEditarCotacao = edtcot;
        this.podeEditarCotacaoSomenteParaCima = edtmai;
    }

    trocarTab(tab: AbaProduto): void {
        this.abaAtiva = tab;
    }

    clonarProdutoDaLista(prod: any): void {
        const codprod = String(prod?.codigo ?? prod?.codprod ?? '').trim();
        if (!codprod) return;
        this.clonarProduto.emit({
            codprod,
            partNumber: String(prod?.partNumber ?? ''),
            nome: String(prod?.nome ?? prod?.descricao ?? ''),
            imagem: prod?.imagem
        });
    }

    abrirCadastroProduto(): void {
        this.irParaCadastro.emit(this.filtro.partNumber);
    }

    async listarUltimasCotacoes(): Promise<void> {
        this.carregando.set(true);
        this.searchbox = true;

        try {
            const [, responseBody] = await Promise.all([
                this.carregarCotacaoDolarDia(),
                this.respostaGateway(this.sankhyaGateway.produtosCotacaoEdicao())
            ]);

            const lista = responseBody?.lista || [];

            this.listaUltimasCotacoes = lista.map((item: any) => {
                const imagemSrc = item.imagem
                    ? `data:image/jpeg;base64,${item.imagem}`
                    : this.gerarPlaceholder(item.descricao || 'PRO');

                const totalCusto = this.arredondar2Casas(item.preco * (1 + item.margCusto / 100));
                const precoVenda = this.arredondar2Casas(totalCusto * (1 + item.margLucro / 100));
                const fabricante = String(item.marca || '').trim().toUpperCase();
                const precoVendaReais = fabricante === 'EMBRAER (NEIVA)'
                    ? precoVenda
                    : this.cotacaoDolarDia > 0
                        ? this.arredondar2Casas(precoVenda * this.cotacaoDolarDia)
                        : null;

                return {
                    codigo: item.CODPROD,
                    partNumber: item.refforn,
                    nome: item.descricao,
                    fabricante: item.marca,
                    fornecedor: item.fornecedor,
                    data: item.data,
                    preco: this.formatar2Casas(item.preco),
                    totcusto: this.formatar2Casas(totalCusto),
                    custo: this.formatar2Casas(item.margCusto),
                    lucro: this.formatar2Casas(item.margLucro),
                    venda: this.formatar2Casas(precoVenda),
                    vendaReais: precoVendaReais === null ? '' : this.formatar2Casas(precoVendaReais),
                    variacao: this.formatar2Casas(item.variacao),
                    usuario: item.usuario,
                    core: this.formatar2Casas(item.core),
                    imagem: imagemSrc,
                    isPlaceholder: !item.imagem
                };
            });

            this.mostrarListaCotacoes = true;
            this.telaVisivel = false;

        } catch (e) {
            console.error('Erro ao listar últimas cotações:', e);
            this.abrirModalErro('Erro ao listar últimas cotações');
        } finally {
            this.carregando.set(false);
        }
    }

    recarregarInicial(): void {
        if (
            !this.filtro.partNumber.trim() &&
            !this.filtro.nome.trim() &&
            !this.filtro.fabricante.trim() &&
            !this.form.marca.trim() &&
            !this.filtro.codigo
        ) {
            this.mostrarListaCotacoes = true;
            this.mostrarLista = false;
            this.telaVisivel = false;
        }
    }

    onDigitarProduto(): void {
        if (this.timeoutBusca) {
            clearTimeout(this.timeoutBusca);
            this.timeoutBusca = null;
        }

        // Invalida qualquer busca em andamento. A resposta dela não deve
        // substituir os resultados da busca correspondente ao texto atual.
        const geracaoBusca = ++this.geracaoBuscaProduto;
        this.carregando.set(false);

        const termo = (
            this.filtro.nome +
            this.filtro.codigo +
            this.filtro.partNumber +
            this.filtro.fabricante
        ).trim();

        if (termo.length < 2) return;

        this.timeoutBusca = setTimeout(() => {
            this.timeoutBusca = null;
            void this.buscarProduto(geracaoBusca);
        }, 300);
    }

    limparBuscaInicial(): void {
        if (this.timeoutBusca) {
            clearTimeout(this.timeoutBusca);
            this.timeoutBusca = null;
        }
        this.geracaoBuscaProduto++;
        this.carregando.set(false);

        this.filtro.partNumber = '';
        this.filtro.nome = '';
        this.filtro.fabricante = '';
        this.filtro.codigo = null;

        this.form.marca = '';
        this.codMarcaEdicao = '';

        this.listaProdutos = [];
        this.listaFabricantesProduto = [];

        this.mostrarListaCotacoes = true;
        this.mostrarLista = false;
        this.telaVisivel = false;
    }

    descartarEdicao(): void {
        if (this.origemEdicao) {
            this.voltarOrigem.emit();
            return;
        }
        this.limparBuscaInicial();
        void this.listarUltimasCotacoes();
    }

    async buscarProduto(geracaoAgendada?: number, validarCamposObrigatorios = false): Promise<void> {
        if (this.timeoutBusca) {
            clearTimeout(this.timeoutBusca);
            this.timeoutBusca = null;
        }

        const geracaoBusca = geracaoAgendada ?? ++this.geracaoBuscaProduto;
        if (geracaoBusca !== this.geracaoBuscaProduto) return;

        // Congela os filtros desta execução: alterações digitadas durante os
        // awaits pertencem à próxima busca, não a esta.
        const filtros = {
            nome: this.filtro.nome.trim(),
            partNumber: this.filtro.partNumber.trim(),
            fabricante: this.filtro.fabricante.trim(),
            codigo: String(this.filtro.codigo || '').trim(),
            marca: this.form.marca.trim()
        };

        if (
            !filtros.partNumber &&
            !filtros.nome &&
            !filtros.fabricante &&
            !filtros.marca &&
            !filtros.codigo
        ) {
            this.recarregarInicial();
            if (validarCamposObrigatorios) {
                this.abrirModalErro('Preencha ao menos um campo para realizar a busca');
            }
            return;
        }

        this.carregando.set(true);

        try {
            const requestBody: any = {};

            if (filtros.nome) {
                requestBody.DESCRICAO = filtros.nome;
            }

            if (filtros.partNumber) {
                requestBody.REFFORN = filtros.partNumber;
            }

            if (filtros.fabricante) {
                requestBody.FABRICANTE = filtros.fabricante;
            }

            if (filtros.codigo) {
                requestBody.CODPROD = filtros.codigo;
            }

            if (filtros.marca) {
                requestBody.MARCA = filtros.marca;
            }

            // Tentar forçar o addon ProdutoGlobalSP a trazer itens inativos
            requestBody.BUSCAR_INATIVOS = 'S';
            requestBody.ATIVO = '*';

            let responseBody: any;
            try {
                responseBody = await this.respostaGateway(
                    this.sankhyaGateway.buscarProdutosEdicao(requestBody)
                );
            } catch (erroPrimeiraTentativa) {
                if (geracaoBusca !== this.geracaoBuscaProduto) return;
                console.warn('Falha na busca de produtos; tentando novamente:', erroPrimeiraTentativa);
                responseBody = await this.respostaGateway(
                    this.sankhyaGateway.buscarProdutosEdicao(requestBody)
                );
            }
            if (geracaoBusca !== this.geracaoBuscaProduto) return;

            const listaBruta = responseBody?.lista || [];
            const lista = listaBruta.filter((item: any) => {
                const cod = Number(item.codprod || item.CODPROD);
                return !isNaN(cod) && cod < 100000;
            });

            const produtosEncontrados = lista.map((item: any) => ({
                partNumber: item.refforn,
                fabricante: item.marca,
                nome: item.descricao,
                codigo: item.codprod,
                condicao: item.condicao || item.CONDICAO || '',
                ativo: item.ativo || item.ATIVO,
                alternativos: [] as ProdutoAlternativo[],
                imagem: item.imagem
                    ? `data:image/jpeg;base64,${item.imagem}`
                    : this.gerarPlaceholder(item.descricao || 'PRO')
            }));

            const produtosComDetalhes = await Promise.all(
                produtosEncontrados.map(async (produto: any) => {
                    const [detalhes, alternativos] = await Promise.all([
                        this.respostaGateway(
                            this.sankhyaGateway.produtoSelecionadoEdicao({ CODPROD: produto.codigo })
                        ).catch(() => null),
                        firstValueFrom(
                            this.sankhyaGateway.carregarProdutosAlternativosNativos(produto.codigo)
                        ).catch(() => [])
                    ]);

                    return {
                        ...produto,
                        condicao: detalhes?.produto?.condicao || produto.condicao || '',
                        alternativos: Array.isArray(alternativos) ? alternativos : []
                    };
                })
            );
            if (geracaoBusca !== this.geracaoBuscaProduto) return;

            const normalizarPartNumber = (valor: unknown): string =>
                String(valor || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
            const partNumberPesquisado = normalizarPartNumber(filtros.partNumber);
            const codigoPesquisado = filtros.codigo;
            produtosComDetalhes.forEach((produto: any) => {
                produto.partNumberExato = !!partNumberPesquisado &&
                    normalizarPartNumber(produto.partNumber) === partNumberPesquisado;
            });
            const correspondeExatamente = (produto: any): boolean =>
                produto.partNumberExato ||
                (!!codigoPesquisado && String(produto.codigo) === codigoPesquisado);
            // Mostra TODOS os produtos encontrados (inclusive os que tambem sao alternativos
            // de outro resultado); o quadro "Produto Alternativo" continua em cada card.
            // Correspondencia exata (PN/codigo) vem primeiro; sem duplicar o mesmo codigo.
            const codigosVistos = new Set<string>();
            const principais: any[] = produtosComDetalhes
                .filter((produto: any) => {
                    const codigo = String(produto.codigo);
                    if (codigosVistos.has(codigo)) return false;
                    codigosVistos.add(codigo);
                    return true;
                })
                .sort((a: any, b: any) => Number(!correspondeExatamente(a)) - Number(!correspondeExatamente(b)));

            // Alternativos que NAO vieram na busca viram card proprio logo abaixo do principal.
            const listaFinal: any[] = [];
            for (const principal of principais) {
                listaFinal.push(principal);
                const faltantes = (principal.alternativos || []).filter(
                    (alt: ProdutoAlternativo) => !codigosVistos.has(String(alt.codprod))
                );
                const cardsBrutos = await Promise.all(faltantes.map(async (alt: ProdutoAlternativo) => {
                    try {
                    codigosVistos.add(String(alt.codprod));
                    let item: any = null;
                    try {
                        const r = await this.respostaGateway(this.sankhyaGateway.buscarProdutosEdicao({
                            CODPROD: String(alt.codprod), BUSCAR_INATIVOS: 'S', ATIVO: '*'
                        }));
                        item = (r?.lista || [])[0] || null;
                    } catch { item = null; }
                    const codigo = item?.codprod || alt.codprod;
                    const [detalhes, altsDoAlt] = await Promise.all([
                        this.respostaGateway(this.sankhyaGateway.produtoSelecionadoEdicao({ CODPROD: codigo })).catch(() => null),
                        firstValueFrom(this.sankhyaGateway.carregarProdutosAlternativosNativos(codigo)).catch(() => [])
                    ]);
                    const nome = item?.descricao || alt.descricao || '';
                    return {
                        partNumber: item?.refforn || alt.partNumber,
                        fabricante: item?.marca || alt.marca,
                        nome,
                        codigo,
                        condicao: detalhes?.produto?.condicao || item?.condicao || item?.CONDICAO || '',
                        ativo: item?.ativo || item?.ATIVO,
                        alternativos: Array.isArray(altsDoAlt) ? altsDoAlt : [],
                        partNumberExato: false,
                        imagem: item?.imagem
                            ? `data:image/jpeg;base64,${item.imagem}`
                            : this.gerarPlaceholder(nome || 'PRO')
                    };
                    } catch (erroAlt) {
                        console.warn('Nao foi possivel carregar o alternativo', alt?.codprod, erroAlt);
                        return null;
                    }
                }));
                listaFinal.push(...cardsBrutos.filter((c: any) => !!c));
            }
            if (geracaoBusca !== this.geracaoBuscaProduto) return;
            this.listaProdutos = listaFinal;

            this.mostrarListaCotacoes = false;
            this.mostrarLista = true;
            this.telaVisivel = false;

        } catch (e) {
            if (geracaoBusca !== this.geracaoBuscaProduto) return;
            console.error('Erro ao buscar produtos:', e);
            this.abrirModalErro('Erro ao buscar produtos');
        } finally {
            if (geracaoBusca === this.geracaoBuscaProduto) {
                this.carregando.set(false);
            }
        }
    }

    async selecionarProduto(prod: any): Promise<void> {
        this.carregando.set(true);
        this.isPlaceholder = prod.isPlaceholder;

        try {
            const cod = prod.codigo;
            this.form.CODPROD = cod;

            // Todas as consultas independentes começam AGORA, em paralelo (antes eram uma
            // depois da outra -- inclusive o local do Aerosys --, somando todas as esperas).
            const pSel = this.respostaGateway(
                this.sankhyaGateway.produtoSelecionadoEdicao({ CODPROD: cod })
            );
            const pCompleto: Promise<any> = firstValueFrom(this.produtoService.buscarProdutoCompleto(cod))
                .then((r) => ({ ok: true, r }), () => ({ ok: false, r: null }));
            // Uma chamada leve traz o Local (empresa padrao) e o Estoque Atual (empresa selecionada).
            this.estoqueAtual = null;
            this.estoqueAtualCarregando = true;
            const pEstoque: Promise<any> = firstValueFrom(this.sankhyaGateway.buscarEstoqueAerosys(cod, this.empresaAerosysSelecionada()))
                .then((r) => ({ ok: true, r }), (e) => ({ ok: false, r: null, e }));
            const pDolar = this.carregarCotacaoDolarDia();
            const pCot = this.carregarCotacoes(cod);
            const pImg = this.carregarImagem(prod.nome || prod.descricao || '');
            const pAlt = this.carregarProdutosAlternativos();
            // Evita "unhandled rejection" caso o produto principal falhe antes de aguardarmos estes.
            [pSel, pDolar, pCot, pImg, pAlt].forEach((p) => (p as Promise<unknown>).catch(() => undefined));

            const response = await pSel;

            if (response?.produto) {
                const p = response.produto;

                this.codprodTela = cod;
                this.form.partNumber = String(p.partNumber ?? '').toUpperCase();
                this.form.descricao = String(p.descricao ?? '').toUpperCase();

                const completo = await pCompleto;
                if (completo.ok && completo.r && completo.r.dados) {
                    const dados = completo.r.dados;
                    const sAtivo = dados['ATIVO'] || dados['ativo'];
                    this.form.ativo = sAtivo === 'S' || sAtivo === 'SIM';
                    this.carregarComplementares(dados);
                } else {
                    const pAtivo = p.ativo ?? p.ATIVO ?? prod.ativo;
                    this.form.ativo = pAtivo === 'S' || pAtivo === 'SIM';
                }

                this.form.tipContest = this.normalizarTipoControle(p.temSerie || p.TEMSERIE);
                this.form.temCore = p.temCore === 'S';
                this.form.codVol = p.codVol || '';
                this.form.marca = p.marca || '';
                this.form.percentualLucro = this.formatar2Casas(p.margLucro) || '0.00';
                this.form.percentualCusto = this.formatar2Casas(p.margCusto) || '0.00';
                this.form.precoFabricante = p.vlrComerc ?? '0.00';
                this.form.valorCore = this.formatar2Casas(p.core) || '0.00';
                this.form.condicao = p.condicao || '';
                // Só o texto escrito à mão (as linhas de cotação ficam apenas no Aerosys).
                this.form.obsInterna = removerLinhasCotacao(p.obsInterna);
                this.form.obsTecnica = p.obsTecnica || '';

                await pDolar;

                const codLocalSankhya = p.codLocalPadrao || p.CODLOCALPADRAO || '';

                // Limpa primeiro
                this.form.codLocalPadrao = null;
                this.form.codLocalPadraoDescricao = '';

                // Local vindo do Aerosys (consulta já em andamento desde o início).
                const est = await pEstoque;
                this.estoqueAtual = est.ok && est.r && est.r.estoqueAtual != null ? Number(est.r.estoqueAtual) : null;
                this.estoqueAtualCarregando = false;
                if (est.ok) {
                    const estoque = est.r;
                    if (estoque && estoque.local) {
                        const localAerosys = String(estoque.local).trim();
                        this.form.codLocalPadrao = localAerosys;
                        this.form.codLocalPadraoDescricao = localAerosys;
                    } else if (codLocalSankhya) {
                        // Fallback caso não tenha no Aerosys mas tenha no Sankhya (improvável)
                        this.form.codLocalPadrao = String(codLocalSankhya);
                        try {
                            let descr = await firstValueFrom(this.produtoService.buscarDescricaoLocal(codLocalSankhya));
                            if (descr && descr.startsWith(codLocalSankhya + ' - ')) {
                                descr = descr.substring(String(codLocalSankhya).length + 3).trim();
                            }
                            this.form.codLocalPadraoDescricao = descr || String(codLocalSankhya);
                        } catch (errDescr) {
                            this.form.codLocalPadraoDescricao = String(codLocalSankhya);
                        }
                    }
                } else {
                    console.warn('Não foi possível carregar o local do Aerosys', est.e);
                    if (codLocalSankhya) {
                        this.form.codLocalPadrao = String(codLocalSankhya);
                        this.form.codLocalPadraoDescricao = String(codLocalSankhya);
                    }
                }

                this.calcular();
            }

            this.mostrarListaCotacoes = false;
            this.mostrarLista = false;
            this.telaVisivel = true;
            this.searchbox = false;

            // Cotações, imagem e alternativos já estavam sendo carregados em paralelo.
            await Promise.all([pCot, pImg, pAlt]);

            this.form.fornecedor = '';

            this.cotacaoOriginal = [
                this.form.precoFabricante,
                this.form.percentualCusto,
                this.form.percentualLucro,
                this.form.valorCore
            ];

            this.salvarEstadoInicial();

        } catch (e) {
            console.error(e);
            this.estoqueAtualCarregando = false;
            this.abrirModalErro('Erro ao selecionar produto');
        } finally {
            this.carregando.set(false);
        }
    }

    /** Preenche os campos complementares (iguais ao Cadastrar Produto) a partir do TGFPRO. */
    private carregarComplementares(d: Record<string, string>): void {
        const v = (k: string) => String(d[k] ?? '').trim();
        const sn = (k: string, padrao: string) => {
            const x = v(k).toUpperCase();
            return x === 'S' || x === 'N' ? x : padrao;
        };
        this.codMarcaEdicao = v('CODMARCA');
        void this.garantirMarcasCache();
        if (!this.codMarcaEdicao) void this.resolverCodMarcaEdicao();
        // GPL_LABEL guarda o texto completo (até 100); DESCRESTRAG (nativo) pode estar truncado.
        this.form.labelUsa = (v('GPL_LABEL') || v('DESCRESTRAG')).toUpperCase();
        this.labelUsaEditadoManual = false;
        this.descricaoEditadaManual = false;
        // Igual ao Cadastrar: Label vazio + Descrição preenchida -> traduz a Descrição para o Label.
        if (!this.form.labelUsa && String(this.form.descricao || '').trim()) {
            this.traduzirDescricaoParaLabel(this.form.descricao);
        }
        this.form.eccn = v('AD_ECCN').toUpperCase();
        this.form.scheduleB = v('AD_SCHEDULEB');
        this.form.codGrupo = v('CODGRUPOPROD');
        this.form.controlaForm = sn('AD_CONTROLAFORM', 'N');
        this.form.matPerig = sn('GPL_MAT_PERIG', 'N');
        this.form.controlado = sn('GPL_CONTROLADO', 'N');
        const limPF = v('GPL_CTRL_LIM_PF');
        const limPJ = v('GPL_CTRL_LIM_PJ');
        this.form.limitePF = this.form.controlado === 'S' ? (limPF ? this.formatar2Casas(limPF) : '5.00') : '';
        this.form.limitePJ = this.form.controlado === 'S' ? (limPJ ? this.formatar2Casas(limPJ) : '200.00') : '';
        const fmtPeso = (x: string) => this.toNumber(x).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
        this.form.pesoBruto = fmtPeso(v('PESOBRUTO'));
        this.form.pesoLiq = fmtPeso(v('PESOLIQ'));
        this.form.ncm = v('NCM');
        this.descricaoNcmAtual = '';
        if (this.form.ncm) {
            this.produtoService.buscarDescricaoNcm(this.form.ncm).subscribe({
                next: (descr) => {
                    const t = (descr || '').trim();
                    this.descricaoNcmAtual = t.startsWith(this.form.ncm + ' - ')
                        ? t.substring(this.form.ncm.length + 3).trim() : t;
                },
                error: () => { this.descricaoNcmAtual = ''; }
            });
        }
    }

    selecionarProdutoAlternativoDaBusca(produto: ProdutoAlternativo, event: Event): void {
        event.stopPropagation();
        void this.selecionarProduto({
            codigo: produto.codprod,
            partNumber: produto.partNumber,
            nome: produto.descricao,
            fabricante: produto.marca
        });
    }

    async carregarProdutosAlternativos(): Promise<void> {
        if (!this.form.CODPROD) {
            this.produtosAlternativos = [];
            return;
        }
        try {
            const response: any = await firstValueFrom(
                this.sankhyaGateway.carregarProdutosAlternativosNativos(this.form.CODPROD)
            );
            this.produtosAlternativos = Array.isArray(response) ? response : [];
        } catch (e) {
            console.error('Erro ao carregar produtos alternativos:', e);
            this.produtosAlternativos = [];
            this.abrirModalErro('Erro ao carregar produtos alternativos');
        }
    }

    private cotacaoDolarCarregadaEm = 0;

    private async carregarCotacaoDolarDia(forcar = false): Promise<void> {
        // A cotação do dia não muda a cada produto aberto: reaproveita por 10 minutos.
        if (!forcar && this.cotacaoDolarDia > 0 && Date.now() - this.cotacaoDolarCarregadaEm < 10 * 60 * 1000) {
            return;
        }
        try {
            const response: any = await firstValueFrom(
                this.sankhyaGateway.buscarCotacoesDemonstrativo()
            );
            const body = response?.responseBody ?? response;
            const cotacaoMaisRecente = body?.cotacoes?.[0];
            const valor = this.toNumber(cotacaoMaisRecente?.valor);
            this.cotacaoDolarDia = body?.sucesso !== false && valor > 0 ? valor : 0;
            this.cotacaoDolarCarregadaEm = Date.now();
        } catch (e) {
            console.warn('Não foi possível carregar a cotação do dólar do dia.', e);
            this.cotacaoDolarDia = 0;
        }
    }

    async abrirModalProdutosAlternativos(): Promise<void> {
        if (!this.form.CODPROD) return;
        this.modalProdutosAlternativosAberto = true;
        this.filtroProdutoAlternativo = '';
        this.marcaProdutoAlternativo = '';
        this.marcaProdutoAlternativoDescricao = '';
        this.produtosAlternativosSelecionados = [];
        await this.buscarProdutosAlternativosModal();
    }

    aoDigitarProdutoAlternativo(): void {
        clearTimeout(this.buscaAlternativosTimer);
        this.buscaAlternativosTimer = setTimeout(() => this.buscarProdutosAlternativosModal(), 300);
    }

    async buscarProdutosAlternativosModal(): Promise<void> {
        if (!this.modalProdutosAlternativosAberto) return;
        this.carregandoProdutosAlternativos = true;
        try {
            const response: any = await firstValueFrom(
                this.sankhyaGateway.pesquisarProdutosAlternativosNativos(
                    this.form.CODPROD,
                    this.filtroProdutoAlternativo,
                    this.marcaProdutoAlternativo
                )
            );
            this.produtosAlternativosBusca = (Array.isArray(response) ? response : []).filter(
                (produto: ProdutoAlternativo) => !this.produtosAlternativos.some(p => p.codprod === produto.codprod)
            );
        } catch (e) {
            console.error('Erro ao pesquisar produtos alternativos:', e);
            this.produtosAlternativosBusca = [];
        } finally {
            this.carregandoProdutosAlternativos = false;
        }
    }

    produtoAlternativoSelecionado(produto: ProdutoAlternativo): boolean {
        return this.produtosAlternativosSelecionados.some(item => item.codprod === produto.codprod);
    }

    alternarProdutoAlternativo(produto: ProdutoAlternativo): void {
        const index = this.produtosAlternativosSelecionados.findIndex(item => item.codprod === produto.codprod);
        if (index >= 0) this.produtosAlternativosSelecionados.splice(index, 1);
        else this.produtosAlternativosSelecionados.push(produto);
    }

    solicitarFecharModalProdutosAlternativos(): void {
        if (!this.produtosAlternativosSelecionados.length) {
            this.fecharModalProdutosAlternativos();
            return;
        }
        this.abrirModal('Deseja descartar as alterações?', () => this.fecharModalProdutosAlternativos());
    }

    fecharModalProdutosAlternativos(): void {
        this.modalProdutosAlternativosAberto = false;
        this.produtosAlternativosBusca = [];
        this.produtosAlternativosSelecionados = [];
    }

    async salvarProdutosAlternativos(): Promise<void> {
        if (!this.produtosAlternativosSelecionados.length) return;
        this.salvandoProdutosAlternativos = true;
        try {
            const response: any = await firstValueFrom(
                this.sankhyaGateway.salvarProdutosAlternativosNativos(
                    this.form.CODPROD,
                    this.produtosAlternativosSelecionados
                )
            );
            if (!response?.sucesso) throw new Error(response?.mensagem || 'Erro ao salvar produtos alternativos.');
            this.fecharModalProdutosAlternativos();
            await this.carregarProdutosAlternativos();
            this.extrasAlterados = true;
            this.exibirToast('Produtos alternativos vinculados com sucesso.');
        } catch (e: any) {
            this.abrirModalErro(e?.message || 'Erro ao salvar produtos alternativos');
        } finally {
            this.salvandoProdutosAlternativos = false;
        }
    }

    solicitarDesvincularProdutoAlternativo(produto: ProdutoAlternativo, event: Event): void {
        event.stopPropagation();
        this.abrirModal(
            'Deseja desvincular o produto da lista de produtos alternativos?',
            () => void this.desvincularProdutoAlternativo(produto)
        );
    }

    private async desvincularProdutoAlternativo(produto: ProdutoAlternativo): Promise<void> {
        try {
            const response: any = await firstValueFrom(
                this.sankhyaGateway.excluirProdutoAlternativoNativo(this.form.CODPROD, produto.codprod)
            );
            if (!response?.sucesso) throw new Error(response?.mensagem || 'Erro ao desvincular produto.');
            await this.carregarProdutosAlternativos();
            this.extrasAlterados = true;
            this.exibirToast('Produto alternativo desvinculado com sucesso.');
        } catch (e: any) {
            this.abrirModalErro(e?.message || 'Erro ao desvincular produto alternativo');
        }
    }

    async carregarCotacoes(codProd: number): Promise<void> {
        try {
            const response = await this.respostaGateway(
                this.sankhyaGateway.cotacoesProdutoEdicao({
                    CODPROD: codProd
                })
            );

            this.cotacoes = (response?.lista || []).map((item: any) => ({
                ...item,
                preco: this.formatar2Casas(item.preco),
                variacao: this.formatar2Casas(item.variacao),
                core: this.formatar2Casas(item.core)
            }));

        } catch (e) {
            console.error('Erro ao buscar cotações:', e);
        }
    }

    calcular(): void {
        const preco = this.toNumber(this.form.precoFabricante);
        const custo = this.toNumber(this.form.percentualCusto);
        const lucro = this.toNumber(this.form.percentualLucro);

        const totalCusto = this.arredondar2Casas(preco * (1 + custo / 100));
        const precoVenda = this.arredondar2Casas(totalCusto * (1 + lucro / 100));

        this.form.precoFabricante = this.formatar2Casas(preco);
        this.form.percentualCusto = this.formatar2Casas(custo);
        this.form.percentualLucro = this.formatar2Casas(lucro);
        this.form.totalCusto = this.formatar2Casas(totalCusto);
        this.form.precoVenda = this.formatar2Casas(precoVenda);

        this.monitorarAlteracao();
    }

    removerVirgulaCampo(campo: string): void {
        if (!this.form[campo]) return;
        this.form[campo] = String(this.form[campo]).replace(/,/g, '');
    }

    formatarCampo(campo: string): void {
        this.form[campo] = this.formatar2Casas(this.toNumber(this.form[campo]));
        this.monitorarAlteracao();
    }

    marcarAlterado(): void {
        this.form.cotacaoalterada = '1';
        this.monitorarAlteracao();
    }

    monitorarAlteracao(): void {
        const atual = { ...this.form };
        delete atual.totalCusto;
        delete atual.precoVenda;

        this.formAlterado = JSON.stringify(atual) !== this.estadoInicial;

        if (this.cotacaoOriginal) {
            const novo = [
                this.form.precoFabricante,
                this.form.percentualCusto,
                this.form.percentualLucro,
                this.form.valorCore
            ];

            this.monitorarCotacao =
                JSON.stringify(novo) !== JSON.stringify(this.cotacaoOriginal);
        }
    }

    salvarEstadoInicial(): void {
        const formMonitorado = { ...this.form };
        delete formMonitorado.totalCusto;
        delete formMonitorado.precoVenda;

        this.estadoInicial = JSON.stringify(formMonitorado);
        this.formAlterado = false;
        this.extrasAlterados = false;
    }

    salvarNovaCotacao(): void {
        this.abrirModal('Deseja realmente salvar as alterações?', () => {
            this.confirmaSalvar();
        });
    }

    // Pergunta do Aerosys: "Deseja atualizar a Data do Preço do Produto, mesmo não havendo mudança no valor?"
    modalDataPreco = false;

    /** Produto alternativo ou foto adicionados/removidos nesta edição: habilita o Salvar mesmo sem mudar o formulário. */
    extrasAlterados = false;

    /** true se Preço Fabricante, Custo %, Lucro % ou Core mudaram desde que o produto foi aberto. */
    private precoFoiAlterado(): boolean {
        if (!this.cotacaoOriginal) return true;
        const atual = [this.form.precoFabricante, this.form.percentualCusto, this.form.percentualLucro, this.form.valorCore];
        return atual.some((v, i) => this.toNumber(v) !== this.toNumber(this.cotacaoOriginal![i]));
    }

    async confirmaSalvar(): Promise<void> {
        // Só foto/alternativo mudaram (formulário igual): salva sem perguntar sobre a data do preço.
        if (!this.formAlterado && this.extrasAlterados && !this.precoFoiAlterado()) {
            await this.executarSalvar(false);
            return;
        }
        // Preço mudou -> a data do preço é atualizada normalmente. Sem mudança, pergunta ao usuário.
        if (!this.precoFoiAlterado()) {
            this.modalDataPreco = true;
            return;
        }
        await this.executarSalvar(true);
    }

    /** Resposta (Sim/Não) da pergunta sobre a data do preço: salva o produto de qualquer forma. */
    async responderDataPreco(atualizar: boolean): Promise<void> {
        this.modalDataPreco = false;
        await this.executarSalvar(atualizar);
    }

    async executarSalvar(atualizarDataPreco: boolean): Promise<void> {
        try {
            const precoCotacao = this.toNumber(this.cotacoes?.[0]?.preco);
            const precoFabricante = this.toNumber(this.form.precoFabricante);

            let variacao = 0;

            if (precoCotacao > 0 && precoFabricante >= 0) {
                variacao = ((precoFabricante - precoCotacao) / precoCotacao) * 100;
                if (!isFinite(variacao) || isNaN(variacao)) variacao = 0;
                variacao = Math.max(-999.99, Math.min(999.99, Number(variacao.toFixed(2))));
            }

            if (variacao > 20) {
                this.exibirToast(
                    `Aviso: a cotação aumentou ${variacao.toFixed(2)}% em relação à última cotação.`
                );
            } else if (variacao < -10) {
                this.exibirToast(
                    `Aviso: a cotação diminuiu ${Math.abs(variacao).toFixed(2)}% em relação à última cotação.`
                );
            }

            // Fornecedor ("Cotação realizada em") só é exigido quando algum valor de
            // preço mudou (Preço Fab., Custo %, Lucro % ou Core) -- comparação numérica.
            if (!this.form.fornecedor && this.precoFoiAlterado() && precoFabricante !== 0) {
                this.abrirModalErro('Informe o fornecedor');
                return;
            }

            if (!this.opcoesCondicaoCombo.some(o => o.valor === this.form.condicao)) {
                this.abrirModalErro('Condição inválida');
                return;
            }

            // ─── Validação de permissão EDTMAI: somente para cima ─────────────
            if (this.podeEditarCotacaoSomenteParaCima && !this.podeEditarCotacao) {
                const precoCotacaoAtual = this.toNumber(this.cotacoes?.[0]?.preco);
                if (precoCotacaoAtual > 0 && precoFabricante < precoCotacaoAtual) {
                    this.abrirModalErro(
                        `Você só pode aumentar o preço. Valor atual: ${this.formatar2Casas(precoCotacaoAtual)}, ` +
                        `valor digitado: ${this.formatar2Casas(precoFabricante)}.`
                    );
                    return;
                }
            }

            //await this.salvarTipoControleProduto();
            const tipContest = this.form.tipContest || 'N';

            // Sankhya recebe SOMENTE a observação escrita à mão. A linha de cotação
            // ("<fornecedor>   <data>   U$ <preço>") é montada pelo backend apenas no Aerosys.
            this.form.obsInterna = removerLinhasCotacao(this.form.obsInterna);

            // Capturado ANTES de limparFiltrosBuscaProduto() (que zera form.marca): senao o
            // produto nacional seguia pro Aerosys como U$.
            const moedaSimboloEdicao = this.isMarcaNacional ? 'R$' : 'U$';
            const codMarcaEdicaoSync = (this.codMarcaEdicao || '').trim();
            const payloadEdicao = {
                CODPROD: this.form.CODPROD,
                FORNEC: this.form.fornecedor || '',
                PRECO: precoFabricante,
                VARIACAO: variacao,
                CORE: this.toNumber(this.form.valorCore),
                LUCRO: this.toNumber(this.form.percentualLucro),
                CUSTO: this.toNumber(this.form.percentualCusto),
                PRECOVENDA: this.toNumber(this.form.precoVenda),
                // Total Custo $ -- precisa ir junto pro backend gravar EST_CUSTO
                // (painel Financeiro, ADENDO_PECAS_ESTOQUE) no Aerosys (2026-09-16).
                TOTALCUSTO: this.toNumber(this.form.totalCusto),
                REFFORN: this.form.partNumber,
                DESCRPROD: this.form.descricao,
                CODVOL: this.form.codVol,
                TEMSERIE: tipContest,
                TEMCORE: this.form.temCore ? 'S' : 'N',
                MARCA: this.form.marca,
                CONDICAO: this.form.condicao,
                OBSTECNICA: this.form.obsTecnica,
                OBSINTERNA: this.form.obsInterna,
                // Label (USA) -> Aerosys (APE_LABEL); backend lê GPL_LABEL.
                GPL_LABEL: this.form.labelUsa || '',
                CODLOCALPADRAO: this.form.codLocalPadrao,
                CODEMP_AEROSYS: this.empresaStateService.codEmpReal
            };
            const response = await this.respostaGateway(
                this.sankhyaGateway.salvarCotacaoProdutoEdicao(payloadEdicao)
            );

            if (response?.sucesso) {
                // Campos complementares (Label USA, ECCN, Schedule B, Grupo, Perigoso, Controlado,
                // Pesos, NCM, Controla FORM): gravados no TGFPRO após o salvamento da cotação.
                const complementares: Record<string, string> = {
                    // Label (USA): só GPL_LABEL (DESCRESTRAG nativo não é mais gravado).
                    GPL_LABEL: this.form.labelUsa || '',
                    AD_ECCN: this.form.eccn || '',
                    AD_SCHEDULEB: this.form.scheduleB || '',
                    CODGRUPOPROD: this.form.codGrupo || '',
                    GPL_MAT_PERIG: this.form.matPerig === 'S' ? 'S' : 'N',
                    GPL_CONTROLADO: this.form.controlado === 'S' ? 'S' : 'N',
                    GPL_CTRL_LIM_PF: this.form.controlado === 'S' ? String(this.toNumber(this.form.limitePF)) : '',
                    GPL_CTRL_LIM_PJ: this.form.controlado === 'S' ? String(this.toNumber(this.form.limitePJ)) : '',
                    PESOBRUTO: String(this.toNumber(this.form.pesoBruto)),
                    PESOLIQ: String(this.toNumber(this.form.pesoLiq)),
                    NCM: this.form.ncm || '',
                    AD_CONTROLAFORM: this.form.controlaForm === 'S' ? 'S' : 'N'
                };
                let avisoComplementares = '';
                try {
                    const resComp = await firstValueFrom(
                        this.produtoService.salvarComplementaresProduto(this.form.CODPROD, complementares)
                    );
                    if (!resComp?.sucesso) {
                        avisoComplementares = resComp?.mensagem || 'Não foi possível gravar os campos complementares.';
                    }
                } catch (eComp) {
                    console.error('Erro ao salvar campos complementares:', eComp);
                    avisoComplementares = 'Não foi possível gravar os campos complementares.';
                }

                this.extrasAlterados = false;
                this.limparFiltrosBuscaProduto();
                this.retornarAposOk = !!this.origemEdicao;
                this.abrirModalOk(avisoComplementares
                    ? `${response.mensagem || 'Salvo com sucesso'} Atenção: ${avisoComplementares}`
                    : (response.mensagem || 'Salvo com sucesso'));
                this.sincronizarEdicaoComAerosys({
                    ...payloadEdicao,
                    ...complementares,
                    ATUALIZAR_DATA_PRECO: atualizarDataPreco,
                    MOEDA_SIMBOLO: moedaSimboloEdicao,
                    // Fabricante (TGFMAR.CODIGO = FAB_ID do Aerosys): permite espelhar a troca de fabricante.
                    CODMARCA: codMarcaEdicaoSync
                });
            } else {
                this.abrirModalErro(response?.mensagem || 'Erro ao salvar');
            }

        } catch (e) {
            console.error('Erro ao salvar:', e);
            this.abrirModalErro('Erro ao salvar');
        }
    }

    private limparFiltrosBuscaProduto(): void {
        this.filtro.partNumber = '';
        this.filtro.nome = '';
        this.filtro.fabricante = '';
        this.filtro.codigo = null;
        this.form.marca = '';
        this.codMarcaEdicao = '';
    }

    async buscarFabricantes(valor: string, destino: 'filtro' | 'produto'): Promise<void> {
        if (!valor || valor.length < 3) {
            if (destino === 'filtro') this.listaFabricantes = [];
            if (destino === 'produto') this.listaFabricantesProduto = [];
            return;
        }

        if (destino === 'produto') {
            await this.garantirMarcasCache();
            if (this.marcasCache.length) {
                const norm = (s: string) => String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
                const termo = norm(valor).trim();
                this.listaFabricantesProduto = this.marcasCache.filter((m) => norm(m.descricao).includes(termo)).slice(0, 30);
                return;
            }
        }

        const responseBody = await this.respostaGateway(
            this.sankhyaGateway.buscarFabricantesEdicao({
                DESCRICAO: valor
            })
        );

        if (destino === 'filtro') {
            this.listaFabricantes = responseBody?.lista || [];
        } else {
            this.listaFabricantesProduto = responseBody?.lista || [];
        }
    }

    selecionarFabricanteProdutoBusca(fab: any): void {
        this.form.marca = fab.descricao;
        this.listaFabricantesProduto = [];
        this.onDigitarProduto();
    }

    selecionarFabricanteProduto(fab: any): void {
        this.form.marca = fab.descricao;
        this.codMarcaEdicao = String(fab.codigo ?? '').trim();
        this.form.percentualCusto = fab.custo;
        this.form.percentualLucro = fab.lucro;
        this.listaFabricantesProduto = [];
        this.calcular();
        this.aceitarMargensDoFabricante();
    }

    /**
     * Trocar o fabricante preenche Custo %/Lucro % com as margens dele. Isso NAO e edicao de valor pelo
     * usuario: atualiza a referencia para que "Cotacao realizada em" so seja exigida quando o usuario
     * realmente mexer em Preco Fab., Custo %, Lucro % ou Core.
     */
    private aceitarMargensDoFabricante(): void {
        if (!this.cotacaoOriginal) return;
        this.cotacaoOriginal = [
            this.cotacaoOriginal[0],
            this.form.percentualCusto,
            this.form.percentualLucro,
            this.cotacaoOriginal[3]
        ];
    }

    // ── Fabricante (Marca) no padrão do Cadastro: "CÓDIGO - Descrição", aceita digitar o código ──
    codMarcaEdicao = '';
    private marcasCache: any[] = [];

    /** Texto exibido no campo: "CÓDIGO - Descrição" (ou só a descrição enquanto não há código). */
    get marcaExibida(): string {
        const desc = (this.form.marca || '').trim();
        return this.codMarcaEdicao ? (desc ? `${this.codMarcaEdicao} - ${desc}` : this.codMarcaEdicao) : desc;
    }

    private async garantirMarcasCache(): Promise<void> {
        if (this.marcasCache.length) return;
        try {
            // Mesma fonte do Cadastro (TGFMAR): traz código, descrição e margens.
            const opcoes: any[] = await firstValueFrom(this.produtoService.buscarMarcas());
            this.marcasCache = (opcoes || []).map((o) => {
                const label = String(o.label ?? '');
                const i = label.indexOf(' - ');
                return {
                    codigo: String(o.valor ?? '').trim(),
                    descricao: i >= 0 ? label.substring(i + 3).trim() : label,
                    custo: o.custo ?? '',
                    lucro: o.lucro ?? ''
                };
            });
        } catch { this.marcasCache = []; }
    }

    /** Produto sem código carregado (só descrição): resolve o código pela lista de marcas. */
    async resolverCodMarcaEdicao(): Promise<void> {
        if (this.codMarcaEdicao || !(this.form.marca || '').trim()) return;
        await this.garantirMarcasCache();
        const alvo = this.form.marca.trim().toUpperCase();
        const fab = this.marcasCache.find((m) => String(m.descricao || '').trim().toUpperCase() === alvo);
        if (fab) this.codMarcaEdicao = String(fab.codigo ?? '').trim();
    }

    /** Igual ao Cadastro: o input mostra o valor calculado (código + descrição). */
    get marcaValorInput(): string {
        return this.marcaExibida;
    }

    /** Ao focar (clique/tab): limpa só o texto VISÍVEL; o valor real só muda ao digitar (igual ao Cadastro). */
    onFocusMarcaEdicao(event: Event): void {
        (event.target as HTMLInputElement).value = '';
    }

    /**
     * Igual ao Cadastro (onInputMarca): o input exibe "CÓDIGO - Descrição"; considera-se código o trecho
     * antes do primeiro " - ". A cada tecla guarda o código, busca a descrição na lista de marcas e
     * reescreve o texto exibido mantendo o cursor dentro do trecho do código (por isso dá para digitar 200).
     */
    onInputMarcaEdicao(event: Event): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;
        const cursorPos = input.selectionStart ?? valorDigitado.length;

        const idx = valorDigitado.indexOf(' - ');
        const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;
        this.codMarcaEdicao = novoCodigo;

        const fab = this.marcasCache.find((m) => String(m.codigo ?? '').trim() === novoCodigo.trim());
        this.form.marca = fab ? fab.descricao : '';
        this.listaFabricantesProduto = [];
        if (fab) {
            this.form.percentualCusto = fab.custo;
            this.form.percentualLucro = fab.lucro;
            this.calcular();
            this.aceitarMargensDoFabricante();
        }
        this.monitorarAlteracao();

        const novoValor = this.marcaExibida;
        setTimeout(() => {
            input.value = novoValor;
            const novaPos = Math.min(cursorPos, novoCodigo.length);
            input.setSelectionRange(novaPos, novaPos);
        });
    }

    limparMarcaEdicao(): void {
        this.form.marca = '';
        this.codMarcaEdicao = '';
        this.listaFabricantesProduto = [];
        const el = document.getElementById('buscaFabricanteProduto') as HTMLInputElement | null;
        if (el) el.value = '';
        this.monitorarAlteracao();
    }

    onBlurMarcaEdicao(event: Event): void {
        (event.target as HTMLInputElement).value = this.marcaExibida;
    }

    async abrirModalFabricantes(destino: 'busca' | 'produto' | 'alternativo', event?: Event): Promise<void> {
        event?.stopPropagation();
        this.fabricanteModalDestino = destino;
        this.filtroFabricanteModal = '';
        this.listaFabricantesProduto = [];
        this.modalFabricantesAberto = true;
        setTimeout(() => (document.querySelector('.mm-overlay .mm-input') as HTMLInputElement | null)?.focus(), 50);
        await this.buscarFabricantesModal('');
    }

    fecharModalFabricantes(): void {
        this.modalFabricantesAberto = false;
        this.filtroFabricanteModal = '';
        this.listaFabricantesModal = [];
        this.carregandoFabricantesModal = false;
    }

    async buscarFabricantesModal(valor: string): Promise<void> {
        this.carregandoFabricantesModal = true;

        try {
            await this.garantirMarcasCache();
            if (this.marcasCache.length) {
                const norm = (s: string) => String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
                const termo = norm(valor || '').trim();
                this.listaFabricantesModal = this.marcasCache.filter((m) =>
                    !termo || norm(m.descricao).includes(termo) || m.codigo.includes(termo));
                return;
            }
            const responseBody = await this.respostaGateway(
                this.sankhyaGateway.buscarFabricantesEdicao({
                    DESCRICAO: valor || ''
                })
            );

            this.listaFabricantesModal = responseBody?.lista || [];
        } catch (e) {
            console.error('Erro ao buscar fabricantes:', e);
            this.listaFabricantesModal = [];
            this.abrirModalErro('Erro ao buscar fabricantes');
        } finally {
            this.carregandoFabricantesModal = false;
        }
    }

    selecionarFabricanteModal(fab: any): void {
        if (this.fabricanteModalDestino === 'alternativo') {
            this.marcaProdutoAlternativo = String(fab.codigo || '');
            this.marcaProdutoAlternativoDescricao = fab.descricao || '';
            this.fecharModalFabricantes();
            void this.buscarProdutosAlternativosModal();
            return;
        }

        if (this.fabricanteModalDestino === 'busca') {
            this.selecionarFabricanteProdutoBusca(fab);
        } else {
            this.selecionarFabricanteProduto(fab);
        }

        this.fecharModalFabricantes();
    }

    async buscarVolumes(valor: string): Promise<void> {
        if (!valor || valor.length < 1) {
            this.listaVolumes = [];
            this.volumeDropdownAberto = false;
            return;
        }

        const responseBody = await this.respostaGateway(
            this.sankhyaGateway.buscarVolumesEdicao({
                DESCRICAO: valor
            })
        );

        this.listaVolumes = responseBody?.lista || [];
        this.volumeDropdownAberto = this.listaVolumes.length > 0;
    }

    abrirVolumes(event?: Event): void {
        event?.stopPropagation();
        this.buscarVolumes(this.form.codVol);
    }

    selecionarVolume(vol: any): void {
        this.form.codVol = vol.descricao;
        this.listaVolumes = [];
        this.volumeDropdownAberto = false;
        this.monitorarAlteracao();
    }

    onToggleTipoControle(valorOpcao: 'E' | 'L', event: Event): void {
        const checked = (event.target as HTMLInputElement).checked;
        this.form.tipContest = checked ? valorOpcao : 'N';
        this.monitorarAlteracao();
    }

    async buscarFornecedores(valor: string): Promise<void> {
        this.fornecedorSelecionado = '';
        const buscaSeq = ++this.fornecedorBuscaSeq;

        if (!valor || valor.trim().length < 2) {
            this.listaFornecedores = [];
            this.fornecedorDropdownAberto = false;
            return;
        }

        const responseBody = await this.respostaGateway(
            this.sankhyaGateway.buscarFornecedoresEdicao({
                DESCRICAO: valor
            })
        );

        if (buscaSeq !== this.fornecedorBuscaSeq || this.form.fornecedor !== valor) {
            return;
        }

        this.listaFornecedores = responseBody?.lista || [];
        this.fornecedorDropdownAberto = this.listaFornecedores.length > 0;
    }

    /** CNPJ/CPF (só dígitos) formatado para exibir na lista de fornecedores. */
    fmtDocFornecedor(doc: string | null | undefined): string {
        const d = String(doc ?? '').replace(/\D/g, '');
        if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        return d;
    }

    abrirFornecedores(event?: Event): void {
        event?.stopPropagation();

        if ((this.form.fornecedor || '').trim().length >= 2 && this.listaFornecedores.length) {
            this.fornecedorDropdownAberto = true;
        }
    }

    selecionarFornecedor(fornec: any): void {
        this.fornecedorBuscaSeq++;
        this.form.fornecedor = fornec.descricao;
        this.fornecedorSelecionado = fornec.descricao;
        this.listaFornecedores = [];
        this.fornecedorDropdownAberto = false;
        this.monitorarAlteracao();
    }

    buscarCondicoes(valor: string): void {
        const termo = (valor || '').trim().toUpperCase();

        if (this.form.condicao !== termo) {
            this.form.condicao = termo;
        }

        if (termo.length < 0) {
            this.listaCondicoesFiltradas = [];
            this.condicaoDropdownAberto = false;
            return;
        }

        this.listaCondicoesFiltradas = this.listaCondicoes.filter((condicao) =>
            condicao.includes(termo)
        );
        this.condicaoDropdownAberto = this.listaCondicoesFiltradas.length > 0;
    }

    abrirCondicoes(event?: Event): void {
        event?.stopPropagation();
        this.buscarCondicoes(this.form.condicao);
    }

    selecionarCondicao(condicao: string): void {
        this.form.condicao = condicao;
        this.listaCondicoesFiltradas = [];
        this.condicaoDropdownAberto = false;
        this.monitorarAlteracao();
    }

    @HostListener('document:click')
    fecharDropdowns(): void {
        this.fornecedorBuscaSeq++;
        this.validarFornecedorDigitado();
        this.validarCondicaoDigitada();
        this.listaFornecedores = [];
        this.listaVolumes = [];
        this.listaCondicoesFiltradas = [];
        this.fornecedorDropdownAberto = false;
        this.volumeDropdownAberto = false;
        this.condicaoDropdownAberto = false;
    }

    listaLocaisFiltrados: any[] = [];

    modalLocaisAberto = false;
    filtroLocalInput = '';

    abrirBuscaLocalModal(): void {
        this.filtroLocalInput = '';
        this.modalLocaisAberto = true;
        this.buscarLocais('');
    }

    fecharBuscaLocalModal(): void {
        this.modalLocaisAberto = false;
    }

    limparLocalPadrao(): void {
        this.form.codLocalPadrao = null;
        this.form.codLocalPadraoDescricao = '';
        this.monitorarAlteracao();
    }

    buscarLocais(valor: string): void {
        const descr = (valor || '').trim().toUpperCase();
        
        if (this.listaLocais.length === 0) {
            this.produtoService.buscarLocais().subscribe({
                next: (resp: any) => {
                    this.listaLocais = (resp || []).map((l: any) => {
                        let labelLimpa = l.label || '';
                        const prefixo = l.valor + ' - ';
                        if (labelLimpa.startsWith(prefixo)) {
                            labelLimpa = labelLimpa.substring(prefixo.length).trim();
                        }
                        return { ...l, label: labelLimpa };
                    });
                    this.filtrarLocais(descr);
                },
                error: () => {
                    this.listaLocais = [];
                    this.listaLocaisFiltrados = [];
                }
            });
        } else {
            this.filtrarLocais(descr);
        }
    }

    private filtrarLocais(descr: string): void {
        if (!descr) {
            this.listaLocaisFiltrados = [...this.listaLocais];
            return;
        }
        
        this.listaLocaisFiltrados = this.listaLocais.filter(l => 
            (l.valor && String(l.valor).toUpperCase().includes(descr)) || 
            (l.label && String(l.label).toUpperCase().includes(descr))
        );
    }

    abrirLocais(event?: Event): void {
        // Obsoleto: Substituido por abrirBuscaLocalModal()
    }

    selecionarLocal(local: any): void {
        this.form.codLocalPadrao = local.valor;
        this.form.codLocalPadraoDescricao = local.label;
        this.listaLocaisFiltrados = [];
        this.modalLocaisAberto = false;
        this.monitorarAlteracao();
    }

    private validarFornecedorDigitado(): void {
        const fornecedor = (this.form.fornecedor || '').trim();

        if (!fornecedor) return;

        const selecionado = this.fornecedorSelecionado &&
            this.fornecedorSelecionado.toUpperCase() === fornecedor.toUpperCase();
        const existeNaLista = this.listaFornecedores.some((fornec) =>
            (fornec.descricao || '').toUpperCase() === fornecedor.toUpperCase()
        );

        if (!selecionado && !existeNaLista) {
            this.form.fornecedor = '';
            this.fornecedorSelecionado = '';
            this.monitorarAlteracao();
        }
    }

    private validarCondicaoDigitada(): void {
        const condicao = (this.form.condicao || '').trim().toUpperCase();

        if (!condicao) return;

        if (!this.opcoesCondicaoCombo.some(o => o.valor.toUpperCase() === condicao)) {
            this.form.condicao = '';
            this.monitorarAlteracao();
        }
    }

    private normalizarTipoControle(temSerie: any): 'E' | 'L' | 'N' {
        const tipo = String(temSerie || '').trim().toUpperCase();

        if (tipo === 'E') {
            return 'E';
        }

        if (tipo === 'L') {
            return 'L';
        }

        return 'N';
    }

    async carregarImagem(descricaoPlaceholder?: string): Promise<void> {
        if (!this.form.CODPROD) return;

        const response = await this.respostaGateway(
            this.sankhyaGateway.buscarImgProdutoEdicao({
                CODPROD: this.form.CODPROD
            })
        );

        if (response?.principal) {
            this.imagemPrincipal = {
                src: `data:image/jpeg;base64,${response.principal}`,
                imgId: 0
            };
        } else {
            this.imagemPrincipal = {
                src: this.gerarPlaceholder(descricaoPlaceholder || this.form.descricao || 'PRO'),
                imgId: 0
            };
        }

        this.listaMiniaturas = (response?.lista || []).map((img: any) => ({
            src: `data:image/jpeg;base64,${img.imagem}`,
            imgId: img.imgId
        }));
    }

    /** Clique na miniatura (igual ao Cadastrar Produto): sem imagem salva abre o seletor de arquivos. */
    cliqueMiniaturaImagem(input: HTMLInputElement): void {
        if (this.imagensPendentes.length > 0) {
            this.mostrarModalSelecaoImagem = true;
            return;
        }
        // A imagem principal tem imgId 0: conta como salva quando nao for o placeholder de letras.
        const temImagemSalva = (this.imagemPrincipal && !this.ehPlaceholder(this.imagemPrincipal))
            || (this.listaMiniaturas ?? []).some((img) => img.imgId !== 0);
        if (temImagemSalva) {
            this.abrirGaleria();
        } else {
            input.click();
        }
    }

    /** Botão "+ Adicionar" da galeria: fecha a galeria e abre o seletor de arquivos. */
    adicionarImagemDaGaleria(): void {
        this.fecharGaleria();
        (document.getElementById('inputImagem') as HTMLInputElement | null)?.click();
    }

    abrirGaleria(imgId?: number): void {
        this.listaImagens = [];

        if (this.imagemPrincipal && !this.ehPlaceholder(this.imagemPrincipal)) {
            this.listaImagens.push(this.imagemPrincipal);
        }

        if (this.listaMiniaturas?.length) {
            this.listaMiniaturas.forEach((img) => {
                if (img.imgId !== 0) this.listaImagens.push(img);
            });
        }

        if (!this.listaImagens.length) return;

        const index = this.listaImagens.findIndex((img) => img.imgId === imgId);
        this.indexImagem = index >= 0 ? index : 0;
        this.imagemAtual = this.listaImagens[this.indexImagem];
        this.modalGaleria = true;
    }

    proximaImagem(): void {
        if (!this.listaImagens.length) return;
        this.indexImagem = (this.indexImagem + 1) % this.listaImagens.length;
        this.imagemAtual = this.listaImagens[this.indexImagem];
    }

    imagemAnterior(): void {
        if (!this.listaImagens.length) return;
        this.indexImagem =
            this.indexImagem <= 0 ? this.listaImagens.length - 1 : this.indexImagem - 1;
        this.imagemAtual = this.listaImagens[this.indexImagem];
    }

    fecharGaleria(): void {
        this.modalGaleria = false;
    }

    /** "×" na miniatura: remove a imagem principal (com confirmacao). */
    removerImagemPrincipal(): void {
        const img = this.imagemPrincipal;
        if (!img || this.ehPlaceholder(img)) return;
        this.abrirModal('Remover a imagem do produto?', () => { void this.deletarImg(img); });
    }

    async deletarImg(img: any): Promise<void> {
        if (!img) return;

        try {
            const response = await this.respostaGateway(
                this.sankhyaGateway.deletarImgProdutoEdicao({
                    CODPROD: this.form.CODPROD,
                    IMGID: img.imgId || 0
                })
            );

            if (response?.mensagem) {
                this.abrirModalAv('Imagem removida com sucesso!');
                this.fecharGaleria();
                await this.carregarImagem();
            }

        } catch (e) {
            console.error('Erro ao excluir imagem:', e);
            this.abrirModalErro('Erro ao excluir imagem');
        }
    }

    async definirComoPadrao(img: any, troca: boolean): Promise<void> {
        if (!img?.src || this.ehPlaceholder(img)) return;

        try {
            const base64 = img.src.split(',')[1];

            const response = await this.respostaGateway(
                this.sankhyaGateway.salvarImgProdutoEdicao({
                    CODPROD: this.form.CODPROD,
                    IMAGEM: base64,
                    PADRAO: true,
                    TROCA: troca,
                    IMGID: img.imgId || 0
                })
            );

            if (response?.mensagem) {
                this.fecharGaleria();
                await this.carregarImagem();
                this.sincronizarImagemComAerosys(base64);
            }

        } catch (e) {
            console.error('Erro ao definir imagem padrão:', e);
        }
    }

    /**
     * Espelha a imagem PADRÃO no Aerosys (servidor de documentos, ver
     * ProdutoAerosysComponent#salvarImagemAerosys) -- best-effort, chamado
     * DEPOIS que a imagem já foi salva no Sankhya com sucesso. Mesmo padrão
     * usado em duplicar-produto.component.ts na criação; aqui cobre também
     * a edição (troca de imagem de um produto já existente).
     */
    private sincronizarImagemComAerosys(base64: string): void {
        if (!this.form.CODPROD || !base64) return;
        this.produtoService.salvarImagemProdutoAerosys({
            CODPROD: String(this.form.CODPROD),
            DESCRPROD: this.form.descricao || '',
            REFFORN: this.form.partNumber || '',
            IMAGEM: base64
        }).subscribe({
            error: (e) => console.warn('Falha ao sincronizar imagem do produto com o Aerosys:', e)
        });
    }

    async onImagemSelecionada(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;
        const files = Array.from(input.files ?? []).filter((file) => file.type.startsWith('image/'));

        if (!files.length) return;

        try {
            const limite = 6;
            const anteriorLen = this.imagensPendentes.length;
            const vagas = limite - anteriorLen;

            if (vagas <= 0) {
                this.abrirModalAv('Limite de 6 imagens atingido.');
                return;
            }

            const selecionadas = files.slice(0, vagas);
            const novas = await Promise.all(
                selecionadas.map(async (file) => {
                    const base64 = await this.processarImagem(file);
                    return { src: `data:image/jpeg;base64,${base64}`, base64 };
                })
            );

            const deveAvisarLimite = files.length > vagas;
            if (deveAvisarLimite) {
                this.abrirSelecaoImagemAposAviso = true;
                this.abrirModalAv(`Apenas ${vagas} imagem(ns) adicionada(s). Limite de 6 imagens atingido.`);
            }

            this.imagensPendentes = [...this.imagensPendentes, ...novas];
            if (this.imagensPendentes.length === 1 || this.indexPadrao < 0) {
                this.indexPadrao = 0;
            }
            this.indexVisualizandoPendente = anteriorLen > 0 ? anteriorLen : 0;
            if (!deveAvisarLimite) {
                this.mostrarModalSelecaoImagem = true;
            }
        } catch (e) {
            console.error(e);
            this.abrirModalErro('Erro ao processar imagem');
        } finally {
            input.value = '';
        }
    }

    removerImagemPendente(index: number, event?: Event): void {
        event?.stopPropagation();
        this.imagensPendentes.splice(index, 1);

        if (this.indexPadrao === index) {
            this.indexPadrao = this.imagensPendentes.length ? 0 : -1;
        } else if (this.indexPadrao > index) {
            this.indexPadrao--;
        }

        if (this.indexVisualizandoPendente >= this.imagensPendentes.length) {
            this.indexVisualizandoPendente = Math.max(0, this.imagensPendentes.length - 1);
        }

        if (!this.imagensPendentes.length) {
            this.cancelarImagem();
        }
    }

    imagemPendenteAnterior(): void {
        if (this.imagensPendentes.length <= 1) return;
        this.indexVisualizandoPendente =
            (this.indexVisualizandoPendente - 1 + this.imagensPendentes.length) % this.imagensPendentes.length;
    }

    proximaImagemPendente(): void {
        if (this.imagensPendentes.length <= 1) return;
        this.indexVisualizandoPendente = (this.indexVisualizandoPendente + 1) % this.imagensPendentes.length;
    }

    async confirmarSalvarImagem(_padrao?: boolean): Promise<void> {
        if (!this.imagensPendentes.length) return;
        if (this.indexPadrao < 0 || this.indexPadrao >= this.imagensPendentes.length) {
            this.abrirModalAv('Selecione a imagem padrao.');
            return;
        }

        try {
            for (let i = 0; i < this.imagensPendentes.length; i++) {
                const padrao = i === this.indexPadrao;
                await this.respostaGateway(
                    this.sankhyaGateway.salvarImgProdutoEdicao({
                        CODPROD: this.form.CODPROD,
                        IMAGEM: this.imagensPendentes[i].base64,
                        PADRAO: padrao,
                        TROCA: padrao,
                        IMGID: 0
                    })
                );
                if (padrao) {
                    this.sincronizarImagemComAerosys(this.imagensPendentes[i].base64);
                }
            }

            this.cancelarImagem();
            this.extrasAlterados = true;
            await this.carregarImagem();
            this.abrirGaleria();
        } catch (e) {
            console.error(e);
            this.abrirModalErro('Erro ao salvar imagem');
        }
    }

    cancelarImagem(): void {
        this.mostrarModalImagem = false;
        this.mostrarModalSelecaoImagem = false;
        this.imagemTemp = '';
        this.previewImagem = '';
        this.imagensPendentes = [];
        this.indexPadrao = -1;
        this.indexVisualizandoPendente = 0;
    }

    copiarTexto(valor: string): void {
        navigator.clipboard.writeText(valor || '');
    }

    abrirModal(mensagem: string, callback: () => void): void {
        this.modalMensagem = mensagem;
        this.acaoConfirmar = callback;
        this.modalConfirm = true;
    }

    fecharModal(): void {
        this.modalConfirm = false;
    }

    confirmarModal(): void {
        this.fecharModal();
        if (this.acaoConfirmar) {
            this.acaoConfirmar();
        }
    }

    abrirModalOk(mensagem: string): void {
        this.modalMensagemOk = mensagem;
        this.modalOk = true;
    }

    fecharModalOk(): void {
        this.modalOk = false;
        if (this.retornarAposOk && this.origemEdicao) {
            this.retornarAposOk = false;
            this.voltarOrigem.emit();
            return;
        }
        this.retornarAposOk = false;
        this.listarUltimasCotacoes();
    }

    abrirModalAv(mensagem: string): void {
        this.modalMensagemAv = mensagem;
        this.modalAv = true;
    }

    fecharModalAv(): void {
        this.modalAv = false;
        if (this.abrirSelecaoImagemAposAviso) {
            this.abrirSelecaoImagemAposAviso = false;
            this.mostrarModalSelecaoImagem = true;
        }
    }

    abrirModalErro(mensagem: string): void {
        this.modalMensagemErro = mensagem;
        this.modalErro = true;
    }

    fecharModalErro(): void {
        this.modalErro = false;
    }

    private async respostaGateway<T = any>(observable: any): Promise<T> {
        const value: any = await firstValueFrom(observable);

        if (!value) {
            throw new Error('Resposta vazia do gateway.');
        }

        if (value.status && value.status !== '1') {
            throw new Error(value.statusMessage || 'Service não retornou sucesso.');
        }

        return (value.responseBody || value) as T;
    }

    toNumber(valor: any): number {
        if (valor === null || valor === undefined || valor === '') return 0;

        let texto = String(valor).trim();

        if (/^(NaN|Infinity|-Infinity)$/i.test(texto)) return 0;

        const ultimoPonto = texto.lastIndexOf('.');
        const ultimaVirgula = texto.lastIndexOf(',');

        if (ultimoPonto !== -1 && ultimaVirgula !== -1) {
            if (ultimaVirgula > ultimoPonto) {
                texto = texto.replace(/\./g, '').replace(',', '.');
            } else {
                texto = texto.replace(/,/g, '');
            }
        } else if (ultimaVirgula !== -1) {
            texto = texto.replace(',', '.');
        }

        return parseFloat(texto) || 0;
    }

    private formatar2Casas(valor: any): string {
        return this.arredondar2Casas(Number(valor || 0)).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    private arredondar2Casas(valor: number): number {
        if (!Number.isFinite(valor)) return 0;
        const sinal = Math.sign(valor);
        const absolutoEmCentavos = Math.abs(valor) * 100;
        const toleranciaBinaria = Number.EPSILON * Math.max(1, absolutoEmCentavos) * 4;
        return sinal * Math.floor(absolutoEmCentavos + 0.5 + toleranciaBinaria) / 100;
    }

    private processarImagem(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event: any) => {
                const img = new Image();

                img.onload = () => {
                    const maxWidth = 800;
                    const maxHeight = 800;
                    const qualidade = 0.7;

                    let { width, height } = img;

                    if (width > height && width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    } else if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }

                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    if (!ctx) {
                        reject('Canvas inválido');
                        return;
                    }

                    canvas.width = width;
                    canvas.height = height;

                    ctx.drawImage(img, 0, 0, width, height);

                    const base64 = canvas.toDataURL('image/jpeg', qualidade);
                    resolve(base64.split(',')[1]);
                };

                img.onerror = reject;
                img.src = event.target.result;
            };

            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    /** Imagens-padrão geradas (letras) NÃO são imagens do produto: nunca podem ser salvas. */

    private placeholdersGerados = new Set<string>();

    ehPlaceholder(img: { src?: string; imgId?: number } | null): boolean {

      return !!img?.src && this.placeholdersGerados.has(img.src);

    }


    private gerarPlaceholder(texto: string): string {
        const letras = texto.substring(0, 3).toUpperCase();
        const cores = ['#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#e67e22', '#e74c3c', '#34495e'];
        const corFundo = cores[Math.floor(Math.random() * cores.length)];

        const size = 200;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext('2d');

        if (!ctx) return '';

        ctx.fillStyle = corFundo;
        ctx.fillRect(0, 0, size, size);

        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 70px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(letras, size / 2, size / 2);

        const url = canvas.toDataURL('image/png');
        this.placeholdersGerados.add(url);
        return url;
    }

    private initTabEnter(): void {
        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key !== 'Enter') return;

            const element = e.target as HTMLElement;

            if (element.tagName === 'TEXTAREA') return;

            e.preventDefault();

            const focusable = Array.from(
                document.querySelectorAll('input, select, textarea, button')
            ).filter((el: any) =>
                !el.disabled &&
                el.type !== 'hidden' &&
                el.offsetParent !== null
            ) as HTMLElement[];

            const index = focusable.indexOf(element);

            if (index > -1 && index < focusable.length - 1) {
                focusable[index + 1].focus();
            }
        });
    }

    private exibirToast(mensagem: string, tempo = 8000): void {
        const container = document.getElementById('toast-container');

        if (!container) return;

        const toast = document.createElement('div');
        toast.className = 'toast-msg';
        toast.textContent = mensagem;

        container.appendChild(toast);

        setTimeout(() => {
            toast.classList.add('show');
        }, 50);

        setTimeout(() => {
            toast.classList.remove('show');

            setTimeout(() => toast.remove(), 350);
        }, tempo);
    }
}
